module.exports = __webpack_public_path__ + "static/media/tatrabanka@2x.e8eecb4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/payment-methods/tatrabanka@2x.png
// module id = 617
// module chunks = 9